export function ErrorBanner({ message }: { message: string }) {
  return (
    <div className="mx-4 my-2 px-4 py-3 rounded-[var(--radius-md)] bg-brand-red-soft text-brand-red text-[14px] font-semibold flex items-start gap-2">
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        className="flex-shrink-0 mt-0.5"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4M12 16h.01" strokeLinecap="round" />
      </svg>
      <span className="leading-snug">{message}</span>
    </div>
  );
}
